module.exports = __webpack_public_path__ + "static/media/photo3.1bcbea20.PNG";